'use client'

import Logo from '$/public/logo/logo.svg'
import { animTransFadeIn, animTransSlideIn } from '@/animations/transitions'
import { useGSAPMedia } from '@/hooks'
import { useStoreTransition } from '@/store'
import { MEDIA } from '@config'
import { useEffect, useRef } from 'react'

const TransitionIn = () => {
  const comp = useRef<any>(null)
  const tl = useRef<GSAPTimeline | null>(null)

  const {
    isTransitionIn,
    isTransitionOut,
    setIsTransitionOut,
    setIsTransitionIn,
    transitionType,
    resetTransition,
    isTransitioning
  } = useStoreTransition()

  useEffect(() => {
    if (isTransitioning) {
      setIsTransitionIn(true)
      //remove trasition out
      setIsTransitionOut(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useGSAPMedia({
    media: MEDIA,
    scope: comp,
    type: 'effect',
    deps: [transitionType, isTransitionIn, isTransitionOut],
    callback: (_c) => {
      if (!transitionType || !isTransitionIn || isTransitionOut) return
      switch (transitionType) {
        case 'slide':
          animTransSlideIn({
            tl: tl.current,
            comp: comp,
            name: 'slide-in',
            onComplete: () => {
              resetTransition()
            }
          })
          break
        case 'fade':
          animTransFadeIn({
            tl: tl.current,
            comp: comp,
            name: 'fade-in',
            onComplete: () => {
              resetTransition()
            }
          })
          break
      }
    }
  })

  if (!isTransitionIn) return null

  return (
    <div ref={comp}>
      {transitionType === 'slide' && (
        <div
          className={
            'bg-primary-200 fixed top-0 left-0 z-2000 flex h-full w-full items-center justify-center'
          }
          data-transition="slide-in"
        >
          <div className="p-x-md absolute inset-0 flex items-center justify-center text-white">
            <Logo className="h-20 w-40" />
          </div>
        </div>
      )}
      {transitionType === 'fade' && (
        <div
          className={
            'fixed top-0 left-0 z-[450] h-full w-full bg-neutral-200 opacity-100'
          }
          data-transition="fade-in"
        />
      )}
    </div>
  )
}

export default TransitionIn
